import React from 'react'
import { useParams } from 'react-router-dom'
import { TicketDetailPage } from 'page-components/auto-ticket'

export const TicketScreen = () => {
    const { id } = useParams()
    return <TicketDetailPage ticketId={id} />
}
